import LabelsModal from './LabelsModal';

export default LabelsModal;
